import React, { useState } from 'react';
import './App.css';
import ValentineLanding from './components/ValentineLanding/ValentineLanding';
import ValentineQuiz from './components/ValentineQuiz/ValentineQuiz';

function App() {
  const [currentView, setCurrentView] = useState('landing'); // 'landing', 'quiz'
  const [quizKey, setQuizKey] = useState(0); // Force quiz reset

  const startQuiz = () => {
    setCurrentView('quiz');
  };

  const goBackToLanding = () => {
    setCurrentView('landing');
    setQuizKey(prev => prev + 1); // Reset quiz state
  };

  return (
    <div className="app">
      <div className="background-diamonds">
        <div className="floating-ornament ornament1">♦</div>
        <div className="floating-ornament ornament2">♦</div>
        <div className="floating-ornament ornament3">♦</div>
        <div className="floating-ornament ornament4">♦</div>
        <div className="floating-ornament ornament5">♦</div>
        <div className="floating-ornament ornament6">♦</div>
        <div className="floating-ornament ornament7">♦</div>
        <div className="floating-ornament ornament8">♦</div>
        <div className="floating-ornament ornament9">♦</div>
        <div className="floating-ornament ornament10">♦</div>
        <div className="floating-ornament ornament11">♦</div>
        <div className="floating-ornament ornament12">♦</div>
        <div className="floating-ornament ornament13">♦</div>
        <div className="floating-ornament ornament14">♦</div>
        <div className="floating-ornament ornament15">♦</div>
        <div className="floating-ornament ornament16">♦</div>
        <div className="floating-ornament ornament17">♦</div>
        <div className="floating-ornament ornament18">♦</div>
        <div className="floating-ornament ornament19">♦</div>
        <div className="floating-ornament ornament20">♦</div>
        <div className="floating-ornament ornament21">♦</div>
        <div className="floating-ornament ornament22">♦</div>
        <div className="floating-ornament ornament23">♦</div>
        <div className="floating-ornament ornament24">♦</div>
        <div className="floating-ornament ornament25">♦</div>
        <div className="floating-ornament ornament26">♦</div>
        <div className="floating-ornament ornament27">♦</div>
        <div className="floating-ornament ornament28">♦</div>
        <div className="floating-ornament ornament29">♦</div>
        <div className="floating-ornament ornament30">♦</div>
        <div className="floating-ornament ornament31">♦</div>
        <div className="floating-ornament ornament32">♦</div>
        <div className="floating-ornament ornament33">♦</div>
        <div className="floating-ornament ornament34">♦</div>
        <div className="floating-ornament ornament35">♦</div>
        <div className="floating-ornament ornament36">♦</div>
        <div className="floating-ornament ornament37">♦</div>
        <div className="floating-ornament ornament38">♦</div>
        <div className="floating-ornament ornament39">♦</div>
        <div className="floating-ornament ornament40">♦</div>
        <div className="floating-ornament ornament41">♦</div>
        <div className="floating-ornament ornament42">♦</div>
        <div className="floating-ornament ornament43">♦</div>
        <div className="floating-ornament ornament44">♦</div>
        <div className="floating-ornament ornament45">♦</div>
        <div className="floating-ornament ornament46">♦</div>
        <div className="floating-ornament ornament47">♦</div>
        <div className="floating-ornament ornament48">♦</div>
        <div className="floating-ornament ornament49">♦</div>
        <div className="floating-ornament ornament50">♦</div>
        <div className="floating-ornament ornament51">♦</div>
        <div className="floating-ornament ornament52">♦</div>
        <div className="floating-ornament ornament53">♦</div>
        <div className="floating-ornament ornament54">♦</div>
        <div className="floating-ornament ornament55">♦</div>
        <div className="floating-ornament ornament56">♦</div>
        <div className="floating-ornament ornament57">♦</div>
        <div className="floating-ornament ornament58">♦</div>
        <div className="floating-ornament ornament59">♦</div>
        <div className="floating-ornament ornament60">♦</div>
      </div>
      
      {currentView === 'landing' && (
        <ValentineLanding onStartQuiz={startQuiz} />
      )}
      {currentView === 'quiz' && (
        <ValentineQuiz 
          key={quizKey}
          onBackToLanding={goBackToLanding} 
        />
      )}
    </div>
  );
}

export default App;
